import apiRegistration from '@/api/registration'

const state = {
  isSubmitting: false,
  state: null,
  phone: null,
  error: null,
  user: null,
  password: null,
}

export const mutationsTypes = {
  addRegisterAdminPhoneStart:
    '[register admin phone] Add register admin phone start',
  addRegisterAdminPhoneSuccess:
    '[register admin phone] Add register admin phone success',
  addRegisterAdminStateSuccess:
    '[register admin phone] Add register admin state success',
  addRegisterAdminPhoneFailure:
    '[register admin phone] Add register admin phone failure',

  addRegisterUserPhoneStart:
    '[register user phone] Add register user phone start',
  addRegisterUserPhoneSuccess:
    '[register user phone] Add register user phone success',
  addRegisterUserStateSuccess:
    '[register user phone] Add register user state success',
  addRegisterUserPhoneFailure:
    '[register user phone] Add register user phone failure',

  getRegisterUserSmsStart: '[register user sms] get register user sms start',
  getRegisterUserSmsSuccess:
    '[register user sms] get register user sms success',
  getRegisterUserSmsFailure:
    '[register user sms] get register user sms failure',

  addRegisterUserSmsStart: '[register user sms] add register user sms start',
  addRegisterUserSmsSuccess:
    '[register user sms] add register user sms success',
  addRegisterUserSmsFailure:
    '[register user sms] add register user sms failure',

  registerUserStart: '[register user] register user start',
  registerUserSuccess: '[register user] register user success',
  registerUserFailure: '[register user] register user failure',

  registerUserChangeDataStart: '[register user] register user ChangeData start',
  registerUserChangeDataSuccess:
    '[register user] register user ChangeData success',
  registerUserChangeDataFailure:
    '[register user] register user ChangeData failure',

  addRegisterUserPasswordStart:
    '[register user] add register user password start',
  addRegisterUserPasswordSuccess:
    '[register user] add register user password success',
  addRegisterUserPasswordFailure:
    '[register user] add register user password failure',

  setUserPassword: '[register user] set user password',

  registerSendCodeUserStart: '[register user] register send code user start',
  registerSendCodeUserSuccess:
    '[register user] register send code user success',
  registerSendCodeUserFailure:
    '[register user] register send code user failure',
}

export const actionsTypes = {
  registerUserSendSmsCode: '[register user] send sms code',
  addRegisterUserPhone: '[register user] Add register user phone',
  addRegisterAdminPhone: '[register user] Add register admin phone',
  getRegisterUserSms: '[register user] get register user sms',
  addRegisterUserSms: '[register user] add register user sms',
  registerUser: '[register user] register user',
  registerUserChangeData: '[register user] register user ChangeData',
  addRegisterUserPassword: '[register user] add register user password',
}

const mutations = {
  [mutationsTypes.addRegisterUserPhoneStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.addRegisterUserPhoneSuccess](state, payload) {
    state.phone = payload
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterUserStateSuccess](state, payload) {
    state.state = payload
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterUserPhoneFailure](state) {
    state.isSubmitting = false
  },

  [mutationsTypes.getRegisterUserSmsStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.getRegisterUserSmsSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.getRegisterUserSmsFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.addRegisterUserSmsStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.addRegisterUserSmsSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterUserSmsFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.registerUserStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.registerUserSuccess](state, payload) {
    state.isSubmitting = false
    state.user = payload
  },
  [mutationsTypes.registerUserFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.registerUserChangeDataStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.registerUserChangeDataSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.registerUserChangeDataFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.addRegisterUserPasswordStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.addRegisterUserPasswordSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.addRegisterUserPasswordFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.registerSendCodeUserStart](state) {
    state.isSubmitting = true
    state.error = null
  },
  [mutationsTypes.registerSendCodeUserSuccess](state) {
    state.isSubmitting = false
  },
  [mutationsTypes.registerSendCodeUserFailure](state, error) {
    state.isSubmitting = false
    state.error = error
  },

  [mutationsTypes.setUserPassword](state, password) {
    state.password = password
  },
}

const actions = {
  [actionsTypes.addRegisterAdminPhone](context, {phone}) {
    context.commit(mutationsTypes.addRegisterAdminPhoneStart)
    return new Promise((resolve, reject) => {
      apiRegistration
        .registrationAdminPhone(phone)
        .then((response) => {
          context.commit(
            mutationsTypes.addRegisterAdminStateSuccess,
            response.state
          )
          context.commit(mutationsTypes.addRegisterAdminPhoneSuccess, phone)
          resolve(response.state)
        })
        .catch((error) => {
          context.commit(mutationsTypes.addRegisterAdminPhoneFailure)
          reject(error)
        })
    })
  },

  [actionsTypes.addRegisterUserPhone](context, {phone}) {
    context.commit(mutationsTypes.addRegisterUserPhoneStart)
    return new Promise((resolve, reject) => {
      apiRegistration
        .registrationUserPhone(phone)
        .then((response) => {
          context.commit(
            mutationsTypes.addRegisterUserStateSuccess,
            response.state
          )
          context.commit(mutationsTypes.addRegisterUserPhoneSuccess, phone)
          resolve(response.state)
        })
        .catch((error) => {
          context.commit(mutationsTypes.addRegisterUserPhoneFailure)
          reject(error)
        })
    })
  },

  [actionsTypes.getRegisterUserSms](context, data) {
    context.commit(mutationsTypes.getRegisterUserSmsStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationCheckSmsCode(data)
        .then((response) => {
          context.commit(mutationsTypes.getRegisterUserSmsSuccess)
          resolve(response.state)
        })
        .catch((error) => {
          context.commit(mutationsTypes.getRegisterUserSmsFailure, error)
        })
    })
  },

  [actionsTypes.addRegisterUserSms](context, data) {
    context.commit(mutationsTypes.addRegisterUserSmsStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationCheckSmsCode(data)
        .then((response) => {
          context.commit(mutationsTypes.addRegisterUserSmsSuccess)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.addRegisterUserSmsFailure, error)
        })
    })
  },

  [actionsTypes.registerUser](context, {state}) {
    context.commit(mutationsTypes.registerUserStart)
    return new Promise((resolve, reject) => {
      apiRegistration
        .registration(state)
        .then((response) => {
          context.commit(mutationsTypes.registerUserSuccess, response)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.registerUserFailure, error)
          reject(error)
        })
    })
  },

  [actionsTypes.registerUserChangeData](context, data) {
    context.commit(mutationsTypes.registerUserChangeDataStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationUserChangeData(data)
        .then((response) => {
          context.commit(mutationsTypes.registerUserChangeDataSuccess, response)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.registerUserChangeDataFailure, error)
        })
    })
  },

  [actionsTypes.addRegisterUserPassword](context, data) {
    context.commit(mutationsTypes.addRegisterUserPasswordStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationUserPassword(data)
        .then((response) => {
          context.commit(
            mutationsTypes.addRegisterUserPasswordSuccess,
            response
          )
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.addRegisterUserPasswordFailure, error)
        })
    })
  },

  [actionsTypes.registerUserSendSmsCode](context, {state}) {
    context.commit(mutationsTypes.registerSendCodeUserStart)
    return new Promise((resolve) => {
      apiRegistration
        .registrationSendSmsCode(state)
        .then((response) => {
          context.commit(mutationsTypes.registerSendCodeUserSuccess, response)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationsTypes.registerSendCodeUserFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
